import * as R from 'ramda'

import { ACTION_COPY, ACTION_DELETE, ACTION_EDIT } from './model'

export const getActions = (state, handlers) => {
  const { actions, id, title, writeable } = state
  const { handleCopy, handleDelete, handleEdit } = handlers

  return R.map(action => {
    const mapTypeToOnClick = {
      [ACTION_EDIT]: () => handleEdit({ id, writeable }),
      [ACTION_COPY]: () => handleCopy({ id, title }),
      [ACTION_DELETE]: () => handleDelete({ id, writeable }),
    }

    return {
      ...action,
      onClick: mapTypeToOnClick[action.type],
    }
  }, actions)
}
